import React, { useState } from 'react';
import ModalCloseIcon from '@/components/general/ModalCloseIcon/ModalCloseIcon';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import Label from '@/components/form/Label/Label';

const diasDisponibles = [
  {
    num: '19',
    mes: 'NOV',
    dia: 'MIÉ',
    horas: ['8:00', '8:30', '10:30', '12:00'],
  },
  {
    num: '26',
    mes: 'NOV',
    dia: 'MIÉ',
    horas: ['8:00', '8:30', '9:00', '9:30'],
  },
  {
    num: '03',
    mes: 'DIC',
    dia: 'MIÉ',
    horas: ['8:00', '8:30', '9:00', '9:30'],
  },
  {
    num: '10',
    mes: 'DIC',
    dia: 'MIÉ',
    horas: ['8:00', '8:30', '9:00', '9:30'],
  },
  {
    num: '17',
    mes: 'DIC',
    dia: 'MIÉ',
    horas: ['8:00', '8:30', '9:00', '9:30'],
  },
  {
    num: '24',
    mes: 'DIC',
    dia: 'MIÉ',
    horas: ['8:00', '8:30', '9:00', '9:30'],
  },
  {
    num: '31',
    mes: 'DIC',
    dia: 'MIÉ',
    horas: ['8:00', '8:30', '9:00', '9:30'],
  },
];

const Step = ({ number, label, active, onClick }) => {
  return (
    <FlexContainer
      className={'flex-column align-items-center pointer'}
      style={{
        minWidth: 80,
      }}
      onClick={onClick}
    >
      <FlexContainer
        className={
          'width-26px height-26px align-items-center justify-center text-12 index-2'
        }
        style={{
          borderRadius: '50%',
          background: active ? '#6f8ec0' : '#ffffff',
          border: active ? '3px solid #6f8ec0' : '3px solid #6f8ec0',
          boxShadow: active ? '0 2px 6px rgba(87,180,62,0.25)' : 'none',
          color: active ? '#fff' : '#000001',
          fontWeight: 800,
        }}
      >
        {number}
      </FlexContainer>

      <Label
        className={'text-10 margt4 text-center width-180px'}
        style={{
          color: '#53595f',
          fontWeight: '700',
        }}
      >
        {label}
      </Label>
    </FlexContainer>
  );
};

const DetalleReasignarHorario2CitaModal = ({ open, onClose }) => {
  const [indexInicio, setIndexInicio] = useState(0);
  const [seleccion, setSeleccion] = useState({ day: null, hour: null });

  if (!open) return null;

  const visibleDays = diasDisponibles.slice(indexInicio, indexInicio + 7);
  const siguiente = () => {
    if (indexInicio < diasDisponibles.length - 7) {
      setIndexInicio(indexInicio + 1);
    }
  };

  const anterior = () => {
    if (indexInicio > 0) {
      setIndexInicio(indexInicio - 1);
    }
  };

  return (
    <FlexContainer
      className="pos-fixed justify-center align-center"
      style={{
        inset: 0,
        background: 'rgba(0,0,0,0.45)',
        zIndex: 9999,
        padding: 20,
      }}
    >
      <FlexContainer
        className="pos-rel flex-column width-900px height-570px bgWhite borderrad20 pad20"
        style={{
          boxShadow: '0 6px 20px rgba(0,0,0,0.20)',
        }}
      >
        <FlexContainer
          onClick={onClose}
          className="pos-abs pointer top16 right16 width-38px height-38px text-22 align-items-center justify-center fontWhite"
          style={{
            background: '#023B7A',
            borderRadius: '50%',
            fontWeight: 'bold',
            boxShadow: '0px 3px 6px rgba(2,59,122,0.3)',
          }}
        >
          <ModalCloseIcon />
        </FlexContainer>

        <FlexContainer
          className="flex-column bgWhite  borderrad16 pad20"
          style={{
            marginBottom: 10,
            transform: 'scale(0.90)',
            transformOrigin: 'center',
          }}
        >
          <FlexContainer className="padlr60 width100 margb8">
            <FlexContainer className="align-items-center pos-rel">
              <FlexContainer
                className="pos-abs left80 right80 top12 height-2px borderrad4 index-1"
                style={{
                  background: '#6f8ec0',
                }}
              />

              <FlexContainer className="justify-between width100 index-2">
                <Step number={1} label={'Especialidad'} active={false} />
                <Step number={2} label={'Médico'} active={false} />
                <Step
                  number={3}
                  label={'Fecha y Hora Disponibles'}
                  active={true}
                />
                <Step
                  number={4}
                  label={'Confirmar Reserva de Cita'}
                  active={false}
                />
              </FlexContainer>
            </FlexContainer>
          </FlexContainer>

          <FlexContainer className={'align-items-center gap-10 padtb0 margb8'}>
            <FlexContainer
              className={
                'align-items-center width-24px height-24px justify-center pointer'
              }
              style={{ borderRadius: '50%', border: '2px solid #6f8ec0' }}
            >
              <span
                className={'text-20 lineHeight-1'}
                style={{ color: '#6f8ec0', fontWeight: 'bold' }}
              >
                ‹
              </span>
            </FlexContainer>

            <div className={'text-18'} style={{ fontWeight: 600 }}>
              <span style={{ color: '#023B7A' }}>
                <strong>Reagenda tu cita |</strong>
              </span>
              <span style={{ color: '#6f8ec0', fontWeight: 500 }}>
                {' '}
                Elige el día y la hora
              </span>
            </div>
          </FlexContainer>

          <FlexContainer className="flex-row gap-16 margt4 width100">
            <FlexContainer className="pos-rel flex-1">
              <select
                className="width100 height-40px padtb6 padr40px padl12 text-14 borderrad4 bgWhite"
                style={{
                  border: '1px solid #C9C9C9',
                  color: '#144796',
                  fontWeight: 600,
                  appearance: 'none',
                }}
              >
                <option>La Molina</option>
                <option>San Isidro</option>
                <option>Miraflores</option>
              </select>

              <span
                className="pos-abs right10 text-24 pointerEventsNone"
                style={{
                  top: '50%',
                  transform: 'translateY(-50%) rotate(270deg)',
                  fontWeight: 900,
                  color: '#144796',
                }}
              >
                ‹
              </span>
            </FlexContainer>

            <FlexContainer className="pos-rel flex-1">
              <select
                className="width100 height-40px padtb6 padr40px padl12 text-14 borderrad4 bgWhite"
                style={{
                  border: '1px solid #C9C9C9',
                  color: '#144796',
                  fontWeight: 600,
                  appearance: 'none',
                }}
              >
                <option>Cardiología</option>
                <option>Ortopedia y Traumatología</option>
                <option>Gastroenterología</option>
              </select>

              <span
                className="pos-abs right10 text-24 pointerEventsNone"
                style={{
                  top: '50%',
                  transform: 'translateY(-50%) rotate(270deg)',
                  fontWeight: 900,
                  color: '#144796',
                }}
              >
                ‹
              </span>
            </FlexContainer>
          </FlexContainer>

          <FlexContainer className="pos-rel width100 margt12">
            <select
              className="width100 height-40px padtb6 padr40px padl12 text-14 borderrad4 bgWhite"
              style={{
                border: '1px solid #C9C9C9',
                color: '#144796',
                fontWeight: 600,
                appearance: 'none',
              }}
            >
              <option>Dr. Christian Soplopuco</option>
              <option>Dr. Martín Salazar</option>
              <option>Dr. Jorge Márquez</option>
              <option>Dr. Luis Cárdenas</option>
            </select>

            <span
              className="pos-abs right10 text-24 pointerEventsNone"
              style={{
                top: '50%',
                transform: 'translateY(-50%) rotate(270deg)',
                fontWeight: 900,
                color: '#144796',
              }}
            >
              ‹
            </span>
          </FlexContainer>
        </FlexContainer>

        <FlexContainer
          className="flex-column bgWhite borderrad16 pad20"
          style={{
            marginBottom: 20,
            transform: 'scale(0.90)',
            transformOrigin: 'center',
          }}
        >
          <FlexContainer
            className="flex-row width100"
            style={{
              marginBottom: 20,
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <FlexContainer
              onClick={anterior}
              className="pointer width-40px height-40px align-center justify-center"
              style={{
                borderRadius: '50%',
                color: '#6f8ec0',
                fontSize: 40,
                fontWeight: 700,
                border: 'none',
              }}
            >
              ‹
            </FlexContainer>

            <FlexContainer
              className="flex-row gap-16"
              style={{ alignItems: 'center' }}
            >
              {visibleDays.map((d, i) => (
                <FlexContainer
                  key={i}
                  className="flex-column align-center pointer align-items-center"
                  style={{
                    background: '#023B7A',
                    color: '#fff',
                    borderRadius: 12,
                    padding: '10px 10px',
                    minWidth: 70,
                  }}
                  onClick={() => setSeleccion(s => ({ ...s, day: d.fecha }))}
                >
                  <Label
                    className="text-16 fontBold"
                    style={{ letterSpacing: '0.5px', fontWeight: 700 }}
                  >
                    {d.num}
                  </Label>

                  <Label
                    className="text-18 fontBold"
                    style={{ lineHeight: '1', margin: '2px 0' }}
                  >
                    <strong>{d.mes}</strong>
                  </Label>

                  <div
                    style={{
                      width: '70%',
                      height: '1px',
                      background: 'rgba(255, 255, 255, 0.5)',
                      margin: '2px 0',
                    }}
                  />

                  <Label className="text-16 fontSemiBold">{d.dia}</Label>
                </FlexContainer>
              ))}
            </FlexContainer>

            <FlexContainer
              onClick={siguiente}
              className="pointer width-40px height-40px align-center justify-center"
              style={{
                borderRadius: '50%',
                color: '#6f8ec0',
                fontSize: 40,
                fontWeight: 700,
                border: 'none',
              }}
            >
              ›
            </FlexContainer>
          </FlexContainer>

          <FlexContainer className="my-custom-scroll width100 height-160px overflowY padr0 pos-rel padb16">
            <FlexContainer
              className="grid padr0 padl60"
              style={{
                gridTemplateColumns: `repeat(${visibleDays.length}, 1fr)`,
                gap: 20,
              }}
            >
              {visibleDays.map((d, i) => (
                <FlexContainer key={i} className="flex-column gap-12">
                  {d.horas.map((hora, h) => (
                    <FlexContainer
                      key={h}
                      onClick={() => setSeleccion({ day: d.fecha, hour: hora })}
                      className="pointer align-center justify-center"
                      style={{
                        background:
                          seleccion.hour === hora && seleccion.day === d.fecha
                            ? '#023B7A'
                            : '#fff',
                        color:
                          seleccion.hour === hora && seleccion.day === d.fecha
                            ? '#fff'
                            : '#023B7A',
                        fontWeight: 700,
                        borderRadius: 10,
                        border: '2px solid #023B7A',
                        padding: '12px 0',
                        transition: '0.2s',
                        width: '88px',
                        boxSizing: 'border-box',
                      }}
                    >
                      {hora}
                    </FlexContainer>
                  ))}
                </FlexContainer>
              ))}
            </FlexContainer>
          </FlexContainer>
        </FlexContainer>
      </FlexContainer>
    </FlexContainer>
  );
};

export default DetalleReasignarHorario2CitaModal;
